import BaseFooterComponent from "./base-footer-component";
import BaseFooterConfig from "./base-footer-config";
import BaseFooterAdvancedConfig from "./base-footer-advanced-config";

export default {
  BaseFooterComponent,
  BaseFooterConfig,
  BaseFooterAdvancedConfig
};
